export type WithId<T> = T & { id: string };

export const withId = <T extends object>(rows: T[], idFn: (row: T) => string): WithId<T>[] =>
  rows.map((r) => ({ ...r, id: idFn(r) }));
